import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const SearchTrafficColumnWrapper = styled(FlexRow)`
    align-items: center;
    gap: 12px;
    width: 100%;
`;

export const PercentageValue = styled.div`
    min-width: 50px;
    white-space: nowrap;
`;
